import React, { useState } from 'react';
import { FieldLabel, TextField } from '@components/textfield';
import {
    Select,
    SelectContent,
    SelectItem,
    SelectTrigger,
    SelectValue
} from '@components/ui/select';
import { CUSTOM_LINK, linkPresets, matchingPresetKey } from './widget-link';

export const LinkField = ({
    communityId,
    link,
    onChange
}: {
    communityId: number;
    link?: string;
    onChange(link: string): void;
}) => {
    const presets = linkPresets(communityId);
    const [custom, setCustom] = useState(
        matchingPresetKey(presets, link) === CUSTOM_LINK
    );
    const selected = custom ? CUSTOM_LINK : matchingPresetKey(presets, link);

    const select = (key: string) => {
        const preset = presets.find((candidate) => candidate.key === key);
        setCustom(!preset);
        if (preset) {
            onChange(preset.link);
        }
    };

    return (
        <div className="flex flex-col gap-1.5">
            <FieldLabel label="Link" />
            <Select value={selected} onValueChange={select}>
                <SelectTrigger size="sm" className="w-full">
                    <SelectValue />
                </SelectTrigger>
                <SelectContent>
                    {presets.map((preset) => (
                        <SelectItem key={preset.key} value={preset.key}>
                            {preset.label}
                        </SelectItem>
                    ))}
                    <SelectItem value={CUSTOM_LINK}>Custom…</SelectItem>
                </SelectContent>
            </Select>
            {custom && (
                <TextField
                    type="text"
                    size="small"
                    placeholder="https://… or an app path such as /whitelabel"
                    value={link ?? ''}
                    onChange={(value) => onChange(String(value))}
                />
            )}
        </div>
    );
};
